// extracted by mini-css-extract-plugin
module.exports = {"container":"Type2_container__3PWNx","checker":"Type2_checker__-s43a","checkmark":"Type2_checkmark__1ICYQ","checkbox":"Type2_checkbox__2OjAd","check-bg":"Type2_check-bg__2g1qj"};